
// JCF
global.module = global.module || {}
var jcf = require("jcf");

// set options for Checkbox module
jcf.setOptions('Select', {
	"wrapNative": false,
	"flipDropToFit": false,
	"maxVisibleItems": 10
});
jcf.setOptions('Radio', {
	"wrapNative": true,
	"checkedClass": "checked",
	"labelActiveClass": "active"
});

// replace all form elements with modified default options
// jcf.replace('button');
jcf.replace('select');
// // jcf.replace('textarea');
jcf.replace('input[type="checkbox"]');
jcf.replace('input[type="file"]');
jcf.replace('input[type="number"]');
jcf.replace('input[type="radio"]');
jcf.replace('input[type="file"]');
jcf.replace('input[type="range"]');
jcf.replace('.jcf-scrollable');


var $ = require("jquery");

require("jquery/package.json"); // jquery is a peer dependency.
const jqueryValidation = require('jquery-validation');

var animateCss = require("animate.css");

var lity = require("lity");

import "@lottiefiles/lottie-player";
import { getUrlParameter } from '../modules/functions.js';



// Custom forms
const modalbody = document.querySelector("body");
const modal_form = document.querySelector(".form");
const modal_form_l = document.querySelector(".form .form__l");
const modal_form_r = document.querySelector(".form .form__r");

const modal_location_quote = document.querySelector('#modal-location-quote');
const mmodal_location_contact = document.querySelector('#modal-location-contact');
const url = window.location.href;
var title = document.title
if(modal_location_quote) {
	modal_location_quote.value = title + '-' + url;
}
if(mmodal_location_contact) {
	mmodal_location_contact.value = title + '-' + url;
}

// Slides modal content
const modal_buttons = document.querySelectorAll(".modal_button");
const wpcf7_response_outputs = document.querySelectorAll(".wpcf7-response-output");
const error_messages = document.querySelectorAll(".error-message");
const error_messages_text = document.querySelectorAll(".error-message p");
modal_buttons.forEach(modal_button => {
	modal_button.addEventListener('click', (e)=> {
		e.preventDefault();
		// Hides the rror messages on form toggle
		error_messages.forEach(error_message => {
			error_message.innerHTML = '';
			error_message.style.display = "none";
		});
		// wpcf7_response_outputs.forEach(wpcf7_response_output => {
		// 	wpcf7_response_output.innerHTML = '';
		// 	wpcf7_response_output.style.display = "none";
		// });
		const quote = document.querySelectorAll("#quote");
		const quote_forms = document.querySelectorAll("#quote *");
		// modal_contact.classList.toggle("toggle");
		modalbody.classList.toggle("modal-slide");
		modal_form.style.transition = "300ms all ease-in-out";
		modal_form_l.style.transition = "300ms all ease-in-out";
		modal_form_r.style.transition = "300ms all ease-in-out";
	});
});

$('input:radio[name="modal_property_type"]').change(function () {
	const id = $('#other_1');
	if ($(this).val() == 'residential') {
		$(id).css('display', 'block');
	} else {
		$(id).css('display', 'none');
	}
});

// vars for all form elements
let modal_property_type = $('input[name="modal_property_type"]'),
	modal_pest_type = $('select[name="modal_pest_type"]'),
	modal_house_type = $('input[name="modal_house_type"]'),
	modal_bedroom_size = $('input[name="modal_bedroom_size"]'),
	modal_location = $('input[name="modal_location"]'),
	modal_file = $('input[name="modal_file"]'),
	modal_textarea = $('textarea[name="modal_textarea"]'),
	modal_business_name = $('input[name="modal_business_name"]'),
	modal_full_name = $('input[name="modal_full_name"]'),
	modal_email = $('input[name="modal_email"]'),
	modal_telephone = $('input[name="modal_telephone"]'),
	modal_checkbox = $('input[name="modal_checkbox"]'),

	// contact_name = $('#contact_name'),
	contact_name = $('input[name="contact_name"]'),
	contact_email = $('input[name="contact_email"]'),
	contact_enquiry = $('textarea[name="contact_enquiry"]'),
	contact_checkbox = $('input[name="contact_checkbox"]'),

	isvalid = 1,
	quoteUrl = "https://vergo.developandtest.uk/wp-content/themes/vergo/template-parts/forms/modal_quote.php",
	contactUrl = "https://vergo.developandtest.uk/wp-content/themes/vergo/template-parts/forms/modal_contact.php",
	current = 1;

const form = $('#quote'),
	progressNumber = document.querySelectorAll(".step").length,
	slidePage = document.querySelector(".slide-page"),
	pages = document.querySelectorAll(".page"),
	nextButtons = document.querySelectorAll(".next"),
	prevButtons = document.querySelectorAll(".prev"),
	stepsNumber = document.querySelectorAll(".page").length;

document.documentElement.style.setProperty("--stepNumber", stepsNumber);

for (let i = 0; i < nextButtons.length; i++) {
	nextButtons[i].addEventListener("click", function (event) {
		event.preventDefault();
		console.log(current);
		if (current == 1) {
			var validationPassed = modal_property_type.valid();
			if (validationPassed == false) {
				return false;
			}
			var validationPassed = modal_pest_type.valid();
			if (validationPassed == false) {
				return false;
			}
			var validationPassed = modal_house_type.valid();
			if (validationPassed == false) {
				return false;
			}
		}
		if (current == 2) {
			var validationPassed = modal_location.valid();
			console.log(validationPassed);
			if (validationPassed == false) {
				return false;
			}
			var validationPassed = modal_file.valid();
			console.log(validationPassed);
			if (validationPassed == false) {
				return false;
			}
		}
		next();
	});
}

for (let i = 0; i < prevButtons.length; i++) {
	prevButtons[i].addEventListener("click", function (event) {
		event.preventDefault();
		prev();
	});
}

const quoteformValidation = $('#wpcf7-f266-o1 .wpcf7-form').validate({
	submitHandler: function () { }, // prevent traditional form submission
	errorClass: "invalid-input",
	rules: {
		'modal_property_type': {
			required: true,
		},
		'modal_pest_type': {
			required: true,
		},
		'modal_house_type': {
			required: true,
		},
		'modal_location': {
			required: true,
		},
		'modal_house_type': {
			required: true,
		},
		'modal_bedroom_size': {
			required: true,
		},
		'modal_full_name': {
			required: true,
		},
		'modal_email': {
			required: true,
			email: true,
		},
		'modal_telephone': {
			required: true,
		},
		'modal_checkbox': {
			required: true,
		},
	},
	messages: {
		modal_property_type: {
			required: "Please select your property type."
		},
		modal_pest_type: {
			required: "Please select your pest concern."
		},
		modal_house_type: {
			required: "Please select your house type."
		},
		modal_file: {
			required: "Please choose a file to upload."
		},
		modal_location: {
			required: "Please enter a location."
		},
		modal_full_name: 'Please enter your name.',
		modal_email: 'Please enter a valid email.',
		modal_telephone: 'Please enter your telephone number.',
		modal_checkbox: 'Please agree to the terms and conditions.',
	},
	errorElement: 'p',
	errorLabelContainer: '.error-message',
});

const contactFormValidation = $('#wpcf7-f3067-o2 .wpcf7-for').validate({
	submitHandler: function () { }, // prevent traditional form submission
	errorClass: "invalid-input",
	rules: {
		'contact_name': {
			required: true,
		},
		'contact_email': {
			required: true,
			email: true
		},
		'contact_enquiry': {
			required: true,
		},
		'contact_checkbox': {
			required: true,
		},
	},
	messages: {
		contact_name: {
			required: "Please enter your name."
		},
		contact_email: {
			required: "Please enter your email."
		},
		contact_enquiry: {
			required: "Please your enquiry."
		},
		contact_checkbox: {
			required: "Please agree to the terms and conditions."
		},
	},
	// validClass: "success",
	errorElement: 'p',
	errorLabelContainer: '.error-message',
	success: function(label) {
		// $(".success-message").html("Thank you for your details");
	},
});

var quoteSubmitBtn = document.querySelector("#wpcf7-f266-o1 .wpcf7-submit");
quoteSubmitBtn.addEventListener("click", function () {
	if (current == 3) {
		var validationPassed = modal_full_name.valid();
		console.log(validationPassed);
		if (validationPassed == false) {
			return false;
		}
		var validationPassed = modal_email.valid();
		console.log(validationPassed);
		if (validationPassed == false) {
			return false;
		}
		var validationPassed = modal_telephone.valid();
		console.log(validationPassed);
		if (validationPassed == false) {
			return false;
		}
		var validationPassed = modal_checkbox.valid();
		console.log(validationPassed);
		if (validationPassed == false) {
			return false;
		}
		setTimeout(function () {
			$(".form__l .success-submit").addClass('sent');
		}, 1000);
	}
});

var contactSubmitBtn = document.querySelector(".form__r .wpcf7 .wpcf7-submit");
contactSubmitBtn.addEventListener("click", function () {
	// Validate required fields else terminate click event
	var validationPassed = contact_name.valid();
	console.log(validationPassed);
	if (validationPassed == false) {
		return false;
	}
	var validationPassed = contact_email.valid();
	console.log(validationPassed);
	if (validationPassed == false) {
		return false;
	}
	var validationPassed = contact_enquiry.valid();
	console.log(validationPassed);
	if (validationPassed == false) {
		return false;
	}
	var validationPassed = contact_checkbox.valid();
	console.log(validationPassed);
	if (validationPassed == false) {
		return false;
	}
	setTimeout(function () {
		$(".form__r .success-submit").addClass('sent');
	}, 1000);
});

function prev() {
	$('.page-'+current).removeClass('current');
	$('.page-' + (current - 1)).addClass('current');
	slidePage.style.marginLeft = `-${(100 / stepsNumber) * (current - 2)}%`;
	current -= 1;
}
function next() {
	// console.log('.page-' + (current + 1));
	$('.page-' + current).removeClass('current');
	$('.page-' + (current + 1)).addClass('current');
	slidePage.style.marginLeft = `-${(100 / stepsNumber) * current}%`;
	current += 1;
}


//
// Lazy load images
//
import { lazyLoadImages } from '../modules/functions.js';

// Add an event listener for facet-wp pagination change
document.addEventListener('facetwp-loaded', () => {
	lazyLoadImages();
});

// Initial lazy load on page load
document.addEventListener('DOMContentLoaded', lazyLoadImages);
